import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles({
  list: {
    width: 400,
  },
  fullList: {
    width: 'auto',
  },
  buttonLink: {
    marginTop: 15,
    marginRight: 15,
    textTransform: 'none',
  },
  backBtn: {
    marginLeft: 15,
    textTransform: 'none',
    marginTop: 15,
    color: '#9e9e9e',
  },
})

export default useStyles
